export var appbarScrollingDirective = {

    mounted(){
        const {appBar} = this.$refs;
        if(appBar){
            window.addEventListener('scroll', ()=>{
                if(appBar && appBar.currentScroll<0){
                    appBar.isActive = true;
                }

                //let scrollPos = window.scrollY;
                /*
                if (appBar.currentScroll < appBar.currentThreshold) {
                    appBar.isActive = true
                  }
                  */
                 /*
                if (appBar.hideOnScroll) {
                    appBar.isActive = (
                        appBar.isScrollingUp 
                        || appBar.currentScroll < appBar.computedScrollThreshold
                    );
                }*/
            })
        }
    }
}